import axios from '../../plugins/axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

// ÐÐ¿ÑÐ¾Ñ Ð·Ð°ÑÐ²Ð¾Ðº Ð´Ð»Ñ Ð¿ÑÐ¾Ð³ÑÐµÑÑÐ° Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸. ÐÐ´ÑÑ Ð¼Ð¸Ð¼Ð¾ plugins/api Ð½Ð°Ð¼ÐµÑÐµÐ½Ð½Ð¾:
// ÑÐ°Ð¼ Ð»ÑÐ±Ð°Ñ ÑÐµÑÐµÐ²Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿Ð¾Ð´Ð½Ð¸Ð¼Ð°ÐµÑ Ð³Ð»Ð¾Ð±Ð°Ð»ÑÐ½ÑÑ Ð¼Ð¾Ð´Ð°Ð»ÐºÑ Ñ Ð¾ÑÐ¸Ð±ÐºÐ¾Ð¹, Ð° Ð·Ð´ÐµÑÑ
// ÑÐ±Ð¾Ð¹Ð½ÑÐ¹ ÑÐ¸Ðº Ð½Ðµ ÑÐ¾Ð±ÑÑÐ¸Ðµ â ÑÐ»ÐµÐ´ÑÑÑÐ¸Ð¹ ÑÐµÑÐµÐ· Ð´Ð²Ðµ ÑÐµÐºÑÐ½Ð´Ñ Ð²ÑÑ ÑÐ°Ð²Ð½Ð¾ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÐ¾ÑÐ¸Ñ.
const getCreditAppealSilent = (params) =>
  axios.get('/api/crm/creditPlatform/getCreditAppeal', {
    params,
    headers: { Authorization: `Bearer ${cookies.get('access_token')}` },
  });

export default getCreditAppealSilent;
